var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _circle4, _circle5, _circle6, _circle7, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _circle8, _polygon, _path15, _polygon2, _path16, _path17, _path18, _polygon3, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon4, _path33, _polygon5, _path34, _circle9, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _rect, _path45, _rect2, _rect3, _path46, _rect4, _rect5, _path47, _rect6, _rect7, _path48, _rect8, _path49, _path50, _circle0, _circle1, _circle10, _path51, _circle11, _path52, _polygon6, _path53, _polygon7, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb535a4d-a035-40f6-99ac-869b240e0289",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 995,
    height: 697.68102,
    viewBox: "0 0 995 697.68102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M915.18858,538.70734H274.35008a16.51866,16.51866,0,0,1-16.5-16.5V127.05353A12.10185,12.10185,0,0,1,269.938,114.96515H919.39146a12.31113,12.31113,0,0,1,12.29712,12.29737V522.20734A16.51867,16.51867,0,0,1,915.18858,538.70734Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M891.81129,515.34051H294.56654c-8.755,0-15.87756-6.66992-15.87756-14.86816v-344.105c0-6.08007,5.27795-11.02685,11.76562-11.02685H895.72828c6.59522,0,11.9607,5.02832,11.9607,11.2085V500.47235C907.689,508.67059,900.56617,515.34051,891.81129,515.34051Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M931.45884,126.10969H257.61851V117.7093a16.57377,16.57377,0,0,1,16.56006-16.54981H914.89878a16.57369,16.57369,0,0,1,16.56006,16.54981Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185.21387,
    cy: 12.5,
    r: 4.28342,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.47268,
    cy: 12.5,
    r: 4.28342,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.73148,
    cy: 12.5,
    r: 4.28342,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M826.07277,457.6286H363.23426a17.5199,17.5199,0,0,1-17.5-17.5V216.97479a13.10307,13.10307,0,0,1,13.0879-13.08838H830.27565a13.31242,13.31242,0,0,1,13.29712,13.29736V440.1286A17.51982,17.51982,0,0,1,826.07277,457.6286ZM358.82216,205.88641a11.10062,11.10062,0,0,0-11.0879,11.08838V440.1286a15.51745,15.51745,0,0,0,15.5,15.5H826.07277a15.51753,15.51753,0,0,0,15.5-15.5V217.18377a11.31,11.31,0,0,0-11.29712-11.29736Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M379.23429,440.1286h430.8385a16,16,0,0,0,16-16V237.58075a16,16,0,0,0-16-16H379.23429a16,16,0,0,0-16,16V424.1286A16,16,0,0,0,379.23429,440.1286Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#f2f2f2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.65354,
    cy: 165.69519,
    r: 9,
    fill: "#ccc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.65354,
    cy: 199.69519,
    r: 9,
    fill: "#ccc"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.65354,
    cy: 233.69519,
    r: 9,
    fill: "#ccc"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.65354,
    cy: 267.69519,
    r: 9,
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M769.15354,267.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M769.15354,301.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M769.15354,335.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M769.15354,369.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M529.15354,403.85468h-29a5.00582,5.00582,0,0,1-5-5v-27a5.00581,5.00581,0,0,1,5-5h29a5.0058,5.0058,0,0,1,5,5v27A5.00581,5.00581,0,0,1,529.15354,403.85468Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#eb367f"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M594.15354,403.85468h-29a5.00573,5.00573,0,0,1-5-5v-61a5.00573,5.00573,0,0,1,5-5h29a5.00573,5.00573,0,0,1,5,5v61A5.00573,5.00573,0,0,1,594.15354,403.85468Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#eb367f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M660.15354,403.85468h-29a5.00573,5.00573,0,0,1-5-5v-95a5.00573,5.00573,0,0,1,5-5h29a5.00573,5.00573,0,0,1,5,5v95A5.00573,5.00573,0,0,1,660.15354,403.85468Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#eb367f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M728.15354,403.85468h-29a5.00573,5.00573,0,0,1-5-5v-128a5.00573,5.00573,0,0,1,5-5h29a5.00573,5.00573,0,0,1,5,5v128A5.00573,5.00573,0,0,1,728.15354,403.85468Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#eb367f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M769.15354,403.85468h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M899.20129,590.40229a10.05578,10.05578,0,0,1,15.32045-1.74338l31.75518-16.38865-1.97486,18.46439L914.44957,603.4668a10.11027,10.11027,0,0,1-15.24828-13.06451Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M926.52427,597.2886a4.50558,4.50558,0,0,1-1.52363-2.21154l-2.52573-8.15935a4.51467,4.51467,0,0,1,1.58686-4.92123l25.73769-19.44037,27.87506-51.71229a14.49652,14.49652,0,1,1,22.9,17.78163L984.716,562.0959a46.37352,46.37352,0,0,1-23.463,22.69646l-30.16279,13.0827a4.505,4.505,0,0,1-3.66895-.0393A4.4547,4.4547,0,0,1,926.52427,597.2886Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 898.77529,
    cy: 363.5412,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "888.812 685.737 876.553 685.736 870.722 638.448 888.817 638.449 888.812 685.737",
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M867.79529,682.2327h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H852.90843a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,867.79529,682.2327Z",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "928.812 685.739 916.553 685.738 910.722 638.449 928.817 638.451 928.812 685.739",
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M907.79529,682.23452h23.64387a0,0,0,0,1,0,0V697.1214a0,0,0,0,1,0,0H892.90843a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,907.79529,682.23452Z",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.208,774.899l-14.36695-.00066a4.50773,4.50773,0,0,1-4.34457-3.3293l-20.67961-76.70114a.50006.50006,0,0,0-.98194.16011l4.17735,72.74238a4.4992,4.4992,0,0,1-4.86667,4.742L974.998,771.16588a4.51234,4.51234,0,0,1-4.096-3.96406L956.19143,614.457l5.69125,3.4153,53.329-9.05421L1036.669,769.80443a4.50072,4.50072,0,0,1-4.46092,5.09453Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M974.02688,630.57892a32.93909,32.93909,0,0,1-16.69168-4.698,4.48018,4.48018,0,0,1-2.13627-4.589c1.87553-11.48624,11.68388-70.40767,20.608-102.52933,3.63463-13.08284,11.67132-20.12935,23.88694-20.94324,17.868-1.172,33.7499,12.8072,35.4036,31.19985,2.91747,32.44838-8.93327,78.55038-14.16384,96.86557a4.49612,4.49612,0,0,1-7.08751,2.30632l-10.66149-8.29346a3.53283,3.53283,0,0,0-4.51612.18827C989.68227,628.10112,981.146,630.57924,974.02688,630.57892Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "906.787 443.738 915.786 481.739 902.784 513.738 911.786 482.739 906.787 443.738",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.29012,484.89818a16.53845,16.53845,0,0,0,6.388-1.15546c.89413-.34453,1.82229-.6277,2.71475-.97246,7.88184-3.04473,13.07419-11.43846,13.26053-19.88589s-4.18791-16.64664-10.68362-22.05029-14.90949-8.17814-23.33455-8.82c-9.07519-.69142-19.29429,1.60955-24.36577,9.16714-1.34994,2.01171-2.29409,4.45248-1.49436,6.88154a4.40355,4.40355,0,0,0,1.24071,1.906c2.26461,2.015,4.52247.50009,6.83114.36634,3.17326-.18383,6.02327,2.38485,7.04751,5.39387s.57317,6.32164-.25409,9.39067a23.459,23.459,0,0,0-1.18275,5.71,5.74055,5.74055,0,0,0,2.37833,5.05482c1.98283,1.19867,4.5869.5051,6.571-.69146s3.69854-2.8603,5.84171-3.74078,5.02247-.685,6.26978,1.26757a6.93469,6.93469,0,0,1,.79255,2.28865c1.11805,5.0949.86105,4.79484,1.97909,9.88974Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M977.22128,752.59121,823.42537,699.0304a10.55633,10.55633,0,0,1-6.48991-13.42571l39.96568-114.75847a7.73373,7.73373,0,0,1,9.83576-4.7548L1025.732,621.46289a7.86747,7.86747,0,0,1,4.83675,10.006L990.647,746.1013A10.55633,10.55633,0,0,1,977.22128,752.59121Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M836.54932,692.4354l134.4838,46.83519a10.22487,10.22487,0,0,0,13.01887-6.29324l32.272-92.66666a10.22487,10.22487,0,0,0-6.29325-13.01886l-134.4838-46.8352a10.22488,10.22488,0,0,0-13.01887,6.29325l-32.272,92.66666A10.22486,10.22486,0,0,0,836.54932,692.4354Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M870.32,627.32885l-6.66027-2.3195a1.44418,1.44418,0,0,1-.88788-1.83677l2.3195-6.66027a1.44418,1.44418,0,0,1,1.83677-.88789l6.66027,2.3195a1.44418,1.44418,0,0,1,.88788,1.83677l-2.3195,6.66027A1.44417,1.44417,0,0,1,870.32,627.32885Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#eb367f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M864.31039,644.585l-6.66027-2.3195a1.44418,1.44418,0,0,1-.88789-1.83677l2.3195-6.66027a1.44418,1.44418,0,0,1,1.83677-.88789l6.66028,2.3195a1.44418,1.44418,0,0,1,.88788,1.83677l-2.3195,6.66027A1.44419,1.44419,0,0,1,864.31039,644.585Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M858.30078,661.84117l-6.66027-2.3195a1.44418,1.44418,0,0,1-.88789-1.83677l2.3195-6.66028a1.44418,1.44418,0,0,1,1.83677-.88788l6.66027,2.3195a1.44418,1.44418,0,0,1,.88789,1.83677l-2.3195,6.66027A1.44419,1.44419,0,0,1,858.30078,661.84117Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M915.07426,639.18089l-32.0904-11.17577a1.44258,1.44258,0,1,1,.94888-2.72465l32.0904,11.17577a1.44258,1.44258,0,1,1-.94888,2.72465Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M909.06464,656.43705l-32.0904-11.17577a1.44258,1.44258,0,0,1,.94889-2.72466l32.0904,11.17578a1.44258,1.44258,0,1,1-.94889,2.72465Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M903.055,673.69321l-32.0904-11.17577a1.44258,1.44258,0,0,1,.94889-2.72466l32.0904,11.17577a1.44258,1.44258,0,0,1-.94889,2.72466Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M988.45374,683.04261c.23367-.56078.45394-1.13069.65639-1.712a30.23861,30.23861,0,0,0-18.61138-38.50142L959.951,673.11628Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#eb367f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M956.88355,674.9589l10.54775-30.28708a30.23857,30.23857,0,1,0,17.955,40.21342Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M994.645,631.51231a10.05576,10.05576,0,0,1,10.9793-10.8264l14.87332-32.49251,9.84082,15.74776-15.63267,28.44114a10.11027,10.11027,0,0,1-20.06077-.87Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ffb8b8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.3943,620.06931a4.50557,4.50557,0,0,1-2.56368-.79992l-7.02273-4.86165a4.51467,4.51467,0,0,1-1.78835-4.85164l8.25508-31.18029-9.9788-57.893a14.49652,14.49652,0,1,1,28.99268-.14028l8.17682,36.12342a46.37349,46.37349,0,0,1-4.45582,32.33866L1024.349,617.713a4.505,4.505,0,0,1-2.91123,2.23327A4.4546,4.4546,0,0,1,1020.3943,620.06931Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.5,798.84051h-190a1,1,0,0,1,0-2h190a1,1,0,0,1,0,2Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "490.541 685.239 502.801 685.238 508.633 637.951 490.539 637.951 490.541 685.239",
    fill: "#a0616a"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M589.914,782.39593l24.14379-.001h.001a15.38605,15.38605,0,0,1,15.38648,15.38623v.5l-39.53052.00147Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "441.541 685.239 453.801 685.238 459.633 637.951 441.539 637.951 441.541 685.239",
    fill: "#a0616a"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M540.914,782.39593l24.14379-.001h.001a15.38605,15.38605,0,0,1,15.38648,15.38623v.5l-39.53052.00147Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#2f2e41"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.98819,
    cy: 333.297,
    r: 24.56103,
    fill: "#a0616a"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M612.00462,776.19239H589.25389a4.50027,4.50027,0,0,1-4.49952-4.55469l1.322-108.03125a1.50006,1.50006,0,0,0-2.989-.20019L569.84666,772.23634a4.50405,4.50405,0,0,1-4.467,3.95605H542.41038a4.49963,4.49963,0,0,1-4.48633-4.85058l15.16748-194.0752.41236-.04492,72.6289-7.84375-9.63306,202.52832A4.49485,4.49485,0,0,1,612.00462,776.19239Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#2f2e41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M553.97556,589.18067a4.49625,4.49625,0,0,1-4.48388-4.3584c-.39649-12.27148-1.07593-54.73242,6.822-85.90527a40.92362,40.92362,0,0,1,37.79272-30.83887h0a41.17944,41.17944,0,0,1,40.5586,26.02344c13.27539,33.70313,25.81787,75.24609,10.18091,81.76172-20.49488,8.53906-74.52344,12.3457-90.59424,13.30859Q554.1129,589.18067,553.97556,589.18067Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M647.84686,409.63245a10.525,10.525,0,0,0,1.24595,1.09311l-2.57824,49.52618-10.72422,5.49051L641.96113,483.01l19.92972-7.87486a8,8,0,0,0,5.0258-8.18055l-5.22116-56.17946a10.4971,10.4971,0,1,0-13.84863-1.14269Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#a0616a"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M646.71807,462.09529l7.54416,21.4389a4.5,4.5,0,0,1-3.38906,5.91156l-22.24542,4.30783a12.49741,12.49741,0,0,1-8.22761-23.60176l19.97367-10.543a4.5,4.5,0,0,1,6.34426,2.48649Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M541.46023,409.63245a10.52654,10.52654,0,0,1-1.24595,1.09311l2.57824,49.52618,10.72421,5.49051L547.346,483.01l-19.92971-7.87486a8,8,0,0,1-5.0258-8.18055l5.22116-56.17946a10.4971,10.4971,0,1,1,13.84863-1.14269Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#a0616a"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M545.19208,459.39926a4.4952,4.4952,0,0,1,3.7412.20954l19.97367,10.543a12.49741,12.49741,0,0,1-8.22761,23.60176l-22.24543-4.30783a4.5,4.5,0,0,1-3.38906-5.91156l7.54417-21.4389A4.495,4.495,0,0,1,545.19208,459.39926Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M605.02743,438.64306a16.14328,16.14328,0,0,1,9.04058-15.16765c7.46588-3.85407,12.156-12.07515,10.10082-19.58209-2.63064-9.60889-15.70861-15.84073-26.30516-12.53479a48.56567,48.56567,0,0,0-8.26083,3.83932l-6.9231,3.711a71.73,71.73,0,0,0-8.534,5.03785,28.31535,28.31535,0,0,0-11.27028,26.53c1.36336,9.76869,7.76069,18.72744,16.51765,24.861a27.93653,27.93653,0,0,0,11.3188,5.03108c4.19751.69206,8.87033-.09445,11.93939-2.70479,4.79626-4.07937,4.30076-10.91072,2.74952-16.61635A12.09016,12.09016,0,0,1,605.02743,438.64306Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#2f2e41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M688.5,798.84051h-190a1,1,0,0,1,0-2h190a1,1,0,0,1,0,2Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M378.4097,616.413,221.63255,680.73031a10.98425,10.98425,0,0,1-14.31518-5.98649l-47.9919-116.983a8.04723,8.04723,0,0,1,4.38557-10.48759l162.0771-66.49162a8.1864,8.1864,0,0,1,10.66888,4.46176L384.39618,602.0978A10.98426,10.98426,0,0,1,378.4097,616.413Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#e6e6e6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M227.31143,666.54132l137.09069-56.241a10.63937,10.63937,0,0,0,5.80508-13.88139L331.45407,501.956a10.63935,10.63935,0,0,0-13.88138-5.80507L180.482,552.39192a10.63934,10.63934,0,0,0-5.80507,13.88138l38.75312,94.46294A10.63935,10.63935,0,0,0,227.31143,666.54132Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 328.66842,
    y: 528.1173,
    width: 2.17853,
    height: 0.36309,
    transform: "translate(-278.3402 63.53163) rotate(-22.30577)",
    fill: "#e6e6e6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M324.74712,530.55065l-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34085-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34086-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34085-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34086-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34085-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34086-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34085-4.07171,1.67041-.13781-.33592,4.07171-1.67041Zm-8.14351,3.34086-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34085-4.07172,1.67041-.13781-.33592,4.07172-1.67041ZM243.312,563.9592l-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34085-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34086-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34085-4.0718,1.67045-.13781-.33592,4.0718-1.67045Zm-8.14351,3.34086-4.07172,1.67041-.13781-.33592,4.07172-1.67041Zm-8.14351,3.34085-4.0718,1.67045-.13781-.33592,4.0718-1.67045Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 192.28502,
    y: 584.06825,
    width: 2.17853,
    height: 0.36309,
    transform: "translate(-309.78171 15.95413) rotate(-22.30577)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 275.30859,
    y: 586.50645,
    width: 2.17853,
    height: 0.36309,
    transform: "translate(-304.4946 47.64812) rotate(-22.30577)",
    fill: "#e6e6e6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M271.44765,588.915l-4.01127,1.64562-.13781-.33592,4.01127-1.64562Zm-8.02254,3.29123-4.01127,1.64561-.13781-.33592,4.01127-1.64561Zm-8.02254,3.29123-4.01127,1.64561-.13782-.33592,4.01128-1.64561ZM247.38,598.78872l-4.01127,1.64561-.13781-.33592,4.01127-1.64561ZM239.35748,602.08l-4.01135,1.64564-.13781-.33592,4.01135-1.64564Zm-8.02263,3.29126-4.01127,1.64561-.13781-.33592,4.01127-1.64561Zm-8.02254,3.29123-4.01127,1.64561-.13781-.33592,4.01127-1.64561Zm-8.02254,3.29123-4.01127,1.64561-.13781-.33592,4.01127-1.64561Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 205.10138,
    y: 615.30879,
    width: 2.17853,
    height: 0.36309,
    transform: "translate(-320.68001 23.15625) rotate(-22.30577)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 242.06964,
    y: 617.41071,
    width: 2.17853,
    height: 0.36309,
    transform: "translate(-318.71151 37.34481) rotate(-22.30577)",
    fill: "#e6e6e6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M238.09306,619.86673l-4.127,1.69309-.13781-.33592,4.127-1.69308Zm-8.25406,3.38621-4.127,1.69309-.13781-.33592,4.127-1.69309Zm-8.254,3.38618-4.127,1.69309-.13781-.33592,4.127-1.69309Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 211.16503,
    y: 630.08925,
    width: 2.17853,
    height: 0.36309,
    transform: "translate(-325.83619 26.5637) rotate(-22.30577)",
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 252.41742,
    y: 642.63399,
    width: 2.17853,
    height: 0.36309,
    transform: "translate(-327.51068 43.15973) rotate(-22.30577)",
    fill: "#e6e6e6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M248.44085,645.09l-4.127,1.69309-.13781-.33592,4.127-1.69309Zm-8.25406,3.38621-4.127,1.69309-.13781-.33592,4.127-1.69309Zm-8.254,3.38617-4.127,1.69309-.13781-.33592,4.127-1.69309Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 221.51281,
    y: 655.31253,
    width: 2.17853,
    height: 0.36309,
    transform: "translate(-334.63536 32.37862) rotate(-22.30577)",
    fill: "#e6e6e6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M233.13244,651.67138,349.3075,604.01085a11.48086,11.48086,0,0,0,6.25718-14.96249L332.092,531.83249l-.22694.10082-28.50928,68.167-21.14465-8.83989a2.7421,2.7421,0,0,0-2.43553.152,2.92176,2.92176,0,0,0-1.212,1.43285l-14.9413,35.7216-15.45982-6.46235a2.75263,2.75263,0,0,0-3.60267,1.478C244.46085,623.82519,234.92848,647.2131,233.13244,651.67138Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#eb367f"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M232.77482,652.21015l-.33494-.14007,11.95457-28.58641a3.08942,3.08942,0,0,1,4.03793-1.65654l15.1545,6.33747,14.85618-35.52489a3.08941,3.08941,0,0,1,4.03792-1.65655l20.83926,8.71479,28.65584-68.52337.33494.14007L303.51512,600.173l-21.17421-8.85486a2.723,2.723,0,0,0-3.56291,1.46168l-14.99625,35.85983-15.48944-6.47754a2.72646,2.72646,0,0,0-3.56291,1.46167Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#3f3d56"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.66667,
    cy: 516.01934,
    r: 2.54162,
    fill: "#3f3d56"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.90562,
    cy: 485.11507,
    r: 2.54162,
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.6623,
    cy: 426.63608,
    r: 2.54162,
    fill: "#3f3d56"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M186.9011,614.29488a10.09493,10.09493,0,0,0,3.60992-15.05255l7.5486-73.80428h-16.3133l-5.99906,72.06608a10.14964,10.14964,0,0,0,11.15384,16.79075Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ffb8b8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.37963,
    cy: 360.46758,
    r: 23.08006,
    fill: "#ffb8b8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M206.22469,568.41934a4.221,4.221,0,0,1-4.06806-3.09992c-1.84912-6.71832-6.66005-18.07734-14.29881-33.76321a27.96723,27.96723,0,0,1,15.8818-38.61269h0a27.95458,27.95458,0,0,1,35.92183,17.808c5.92086,18.56279,5.635,38.447,5.23719,46.13351a4.239,4.239,0,0,1-3.32085,3.9139l-34.4462,7.52221A4.20772,4.20772,0,0,1,206.22469,568.41934Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ff6584"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.082 686.425 148.602 686.425 154.083 641.988 137.08 641.989 137.082 686.425",
    fill: "#ffb8b8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M237.11328,784.29259H273.3207a0,0,0,0,1,0,0v13.98923a0,0,0,0,1,0,0H251.10251a13.98923,13.98923,0,0,1-13.98923-13.98923v0a0,0,0,0,1,0,0Z",
    transform: "translate(407.97009 1481.40327) rotate(179.99738)",
    fill: "#2f2e41"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "21.882 671.495 31.978 677.045 58.19 640.747 43.291 632.555 21.882 671.495",
    fill: "#ffb8b8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M118.19573,776.43687h36.20742a0,0,0,0,1,0,0V790.4261a0,0,0,0,1,0,0h-22.2182a13.98922,13.98922,0,0,1-13.98922-13.98922v0a0,0,0,0,1,0,0Z",
    transform: "translate(-224.19403 1434.45667) rotate(-151.19904)",
    fill: "#2f2e41"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M239.04362,762.92032a4.22817,4.22817,0,0,1-4.18943-3.68448L220.44641,648.21146a2.34928,2.34928,0,0,0-4.387-.83233L156.0137,756.31946a4.25173,4.25173,0,0,1-5.20851,1.91152L137.717,753.24432a4.2283,4.2283,0,0,1-2.41119-5.54553L176.901,645.51807a3.25729,3.25729,0,0,0,.21244-.80939c5.63385-43.60531,19.96822-65.78009,24.22716-71.5376a3.27464,3.27464,0,0,0,.466-2.98154l-.58548-1.75643a4.22648,4.22648,0,0,1,.81376-4.113c15.34656-17.47993,42.095-7.94158,42.36346-7.84339l.134.04955.084.11471c29.99294,41.13309,18.90348,174.73235,16.376,201.09633a4.21706,4.21706,0,0,1-3.88476,3.80561l-17.73551,1.36551C239.2618,762.91664,239.15236,762.92032,239.04362,762.92032Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#2f2e41"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M291.60621,488.437a9.89229,9.89229,0,0,0-.22487,1.54123l-40.36722,23.2877-9.81182-5.6485-10.46,13.69361,16.39813,11.68759a7.51761,7.51761,0,0,0,9.01944-.21974l41.62555-32.83868a9.86415,9.86415,0,1,0-6.17923-11.50321Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ffb8b8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M249.6646,514.36888l-13.04658,16.909a4.22868,4.22868,0,0,1-6.39366.3502L215.45475,516.291a11.74385,11.74385,0,0,1,14.40248-18.55361l18.52432,10.35814a4.22869,4.22869,0,0,1,1.28305,6.27338Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ff6584"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M199.09786,543.74606l-21.01724-3.795a4.22868,4.22868,0,0,1-3.255-5.51424L181.639,514.2639a11.74385,11.74385,0,0,1,23.1015,4.24132l-.66475,21.21319a4.2287,4.2287,0,0,1-4.97792,4.02765Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ff6584"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M205.53264,456.31837c5.93207,4.06,13.721,8.23343,19.77971,3.90987a11.02532,11.02532,0,0,0,3.61842-12.70935c-2.9011-8.29622-10.87182-11.94861-18.49383-14.74824-9.90861-3.63952-20.69763-6.53492-30.92666-3.92847s-19.26917,12.51018-17.42263,22.90329c1.48494,8.35793,9.36882,15.31239,8.24961,23.7271-1.1264,8.46874-10.65039,12.92645-19.05857,14.44s-17.81712,1.99988-23.85974,8.03934c-7.70847,7.70443-5.78353,21.47525,1.46982,29.60959s18.19907,11.82157,28.80546,14.32819c14.05282,3.32112,29.252,5.0665,42.59867-.44522s23.73281-20.34863,19.8665-34.26132c-1.63312-5.87671-5.48026-10.84332-9.19832-15.67848s-7.48294-9.89132-8.90121-15.82354c-1.18189-4.94351-.30712-10.68318,2.97117-14.39139a4.16949,4.16949,0,0,0,.55855-4.8737Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#2f2e41"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M293.5,798.84051h-190a1,1,0,0,1,0-2h190a1,1,0,0,1,0,2Z",
    transform: "translate(-102.5 -101.15949)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawData);
export default __webpack_public_path__ + "static/media/undraw_data.3c2ec0974d97db27a987ef1c8b3e4d75.svg";
export { ForwardRef as ReactComponent };